export default {
    title: "Integrazione Email",
    subtitle: "Collega i tuoi account email per importare automaticamente i documenti dagli allegati",
    addAccount: "Aggiungi Account Email",

    // Empty state
    noAccounts: "Nessun account email collegato",
    noAccountsDescription: "Collega un account email per permettere a Eve di importare automaticamente i documenti dalla tua casella di posta.",
    getStarted: "Inizia",

    // Account list
    accountsList: {
        title: "Account Collegati",
        lastSync: "Ultima sincronizzazione",
        neverSynced: "Mai sincronizzato",
        justNow: "Adesso",
        minutesAgo_one: "{{count}} minuto fa",
        minutesAgo_other: "{{count}} minuti fa",
        hoursAgo_one: "{{count}} ora fa",
        hoursAgo_other: "{{count}} ore fa",
        syncNow: "Sincronizza",
        syncing: "Sincronizzazione...",
        toggleSync: "Attiva/disattiva sincronizzazione automatica",
        syncEnabled: "Sincronizzazione automatica attivata",
        syncDisabled: "Sincronizzazione automatica disattivata",
        configRequired: "Configura le impostazioni di sincronizzazione per iniziare",
        syncStarted: "Processo di sync avviato con successo",
        syncInProgress: "Sync in corso",
        syncingInfoTooltip: "Le azioni saranno di nuovo disponibili a fine processo di sync.",
        stopSync: "Arresta sync",
    },

    // Status badges
    status: {
        active: "Connesso",
        inactive: "Inattivo",
        error: "Errore",
        authentication_required: "Riconnessione Richiesta",
        syncing: "Sincronizzazione",
    },

    // Provider names
    providers: {
        gmail: "Gmail",
        outlook: "Outlook",
        imap_smtp: "IMAP/SMTP",
    },

    // Actions
    actions: {
        configure: "Configura",
        reconnect: "Riconnetti",
        remove: "Rimuovi",
        cancel: "Annulla",
        back: "Indietro",
        continue: "Continua",
        connect: "Collega Account",
        test: "Testa Connessione",
        save: "Salva Modifiche",
        saving: "Salvataggio...",
        close: "Chiudi",
    },

    // Wizard
    wizard: {
        title: "Collega Account Email",
        steps: {
            email: "Indirizzo Email",
            connect: "Connessione",
            success: "Completato",
        },
    },

    // Step 1: Email Entry
    emailEntry: {
        title: "Inserisci il tuo indirizzo email",
        description: "Rileveremo automaticamente il modo migliore per connetterci in base al tuo provider.",
        emailLabel: "Indirizzo Email",
        emailPlaceholder: "tu@azienda.com",
        emailRequired: "L'indirizzo email è obbligatorio",
        emailInvalid: "Inserisci un indirizzo email valido",
        displayNameLabel: "Nome Visualizzato (opzionale)",
        displayNamePlaceholder: "es. Email Lavoro, Casella Documenti",
        displayNameHint: "Un nome amichevole per identificare questo account",
        providerDetected: "Provider rilevato: {{provider}}",
    },

    // Step 2A: Gmail OAuth
    gmailOAuth: {
        title: "Collega Gmail",
        description: "Accedi con il tuo account Google per autorizzare Eve a leggere le tue email.",
        secureAccess: "Accesso Sicuro con Google",
        permissionsTitle: "Eve richiederà i seguenti permessi:",
        permissionRead: "Leggere le tue email e allegati",
        permissionModify: "Contrassegnare le email come lette dopo l'elaborazione",
        signInButton: "Accedi con Google",
        redirectNote: "Verrai reindirizzato alla pagina di login di Google.",
    },

    // Step 2B: Outlook OAuth
    outlookOAuth: {
        title: "Collega Outlook",
        description: "Accedi con il tuo account Microsoft per autorizzare Eve a leggere le tue email.",
        secureAccess: "Accesso Sicuro con Microsoft",
        permissionsTitle: "Eve richiederà i seguenti permessi:",
        permissionRead: "Leggere le tue email e allegati",
        permissionModify: "Contrassegnare le email come lette dopo l'elaborazione",
        signInButton: "Accedi con Microsoft",
        redirectNote: "Verrai reindirizzato alla pagina di login di Microsoft.",
    },

    // Step 2C: IMAP Configuration
    imapConfig: {
        title: "Configura Server Email",
        description: "Inserisci le impostazioni del tuo server email per collegare l'account.",
        presetLabel: "Provider Email",
        presetPlaceholder: "Seleziona il tuo provider email...",
        customOption: "Configurazione Manuale / Altro",

        imapSection: "Posta in Arrivo (IMAP)",
        imapHost: "Server IMAP",
        imapHostPlaceholder: "imap.esempio.com",
        imapHostRequired: "Il server IMAP è obbligatorio",
        imapPort: "Porta",
        imapUseSsl: "Usa SSL/TLS",

        smtpSection: "Posta in Uscita (SMTP)",
        smtpHost: "Server SMTP",
        smtpHostPlaceholder: "smtp.esempio.com",
        smtpPort: "Porta",
        smtpUseSsl: "Usa SSL/TLS",

        credentialsSection: "Credenziali",
        username: "Nome Utente",
        usernamePlaceholder: "Solitamente il tuo indirizzo email",
        password: "Password / App Password",
        passwordPlaceholder: "Inserisci la password",
        passwordRequired: "La password è obbligatoria",

        appPasswordHint: "Se hai l'autenticazione a due fattori attiva, dovrai usare una App Password invece della tua password normale.",
        appPasswordLink: "Scopri come creare una App Password",

        testConnection: "Testa Connessione",
        testing: "Test connessione in corso...",
        testSuccess: "Connessione riuscita!",
        testFailed: "Connessione fallita",
        testFailedMessage: "Impossibile connettersi: {{error}}",

        connecting: "Connessione in corso...",
    },

    // Step 3: Success
    success: {
        title: "Account Collegato!",
        description: "Il tuo account email è stato collegato con successo a Eve.",
        whatHappensNext: "Cosa succede ora?",
        step1: "Eve monitorerà la tua casella per nuove email con allegati",
        step2: "PDF e documenti allegati verranno importati automaticamente",
        step3: "Troverai i documenti importati nella sezione Documenti",
        viewAccounts: "Vedi Account Collegati",
        addAnother: "Aggiungi Altro Account",
    },

    // Remove confirmation
    removeConfirm: {
        title: "Rimuovi Account Email",
        message: "Sei sicuro di voler rimuovere {{email}}? Eve smetterà di importare documenti da questo account.",
        confirm: "Rimuovi Account",
        cancel: "Annulla",
    },

    // Stop sync confirmation
    stopSyncConfirm: {
        title: "Arresta sync?",
        message: "Il sync in corso potrà completarsi. Il sync automatico sarà disattivato e le azioni torneranno disponibili a fine processo.",
        cancel: "Annulla",
        confirm: "Arresta sync",
        stopping: "Arresto in corso...",
    },

    // Configure modal
    configure: {
        title: "Configura Account",
        disclaimer: "Questa integrazione legge le email in modo silenzioso, senza modificare lo stato letto/non letto dei messaggi.",
        autoProcess: "Elabora allegati automaticamente",
        autoProcessHint: "Crea automaticamente documenti dagli allegati delle email",
        allowedDomains: "Domini mittente consentiti",
        allowedDomainsPlaceholder: "es. fornitore.com, cliente.com",
        allowedDomainsHint: "Elabora solo email da questi domini. Lascia vuoto per elaborare tutti.",
        foldersToWatch: "Cartelle da monitorare",
        foldersToWatchHint: "Seleziona quali cartelle email monitorare per nuove email",
        selectFolders: "Seleziona cartelle...",
        loadingFolders: "Caricamento cartelle...",
        syncFromDate: "Sincronizza email da",
        syncFromDateHint: "Scegli da quale data importare le email. Applicato alla prima sincronizzazione.",
        syncFromNone: "Solo nuove email (predefinito)",
        syncFromToday: "Da oggi",
        syncFrom7days: "Ultimi 7 giorni",
        syncFrom30days: "Ultimi 30 giorni",
        syncFromCustom: "Data personalizzata",
        syncFromDateAlreadySynced: "Questo account è già stato sincronizzato. La data si applica solo alla prima sincronizzazione.",
        syncConfirmTitle: "Sincronizza email?",
        syncConfirmMessage: "Vuoi procedere con la sincronizzazione delle email ora?",
        syncNow: "Sincronizza",
    },

    // Email view modal
    emailView: {
        title: "Dettagli Email",
        subtitle: "Visualizza il contenuto dell'email e gli allegati",
        from: "Da",
        to: "A",
        subject: "Oggetto",
        date: "Data",
        body: "Contenuto",
        attachments: "Allegati",
        noSubject: "(Nessun oggetto)",
        noContent: "Nessun contenuto disponibile per questa email.",
        errorLoading: "Impossibile caricare i dettagli dell'email.",
        processed: "Elaborato",
    },

    // OAuth callbacks
    oauth: {
        success: "Account {{provider}} collegato con successo!",
        error: "Impossibile collegare l'account {{provider}}",
        errorGeneric: "Impossibile collegare l'account email. Riprova.",
    },

    // Errors
    errors: {
        loadAccounts: "Impossibile caricare gli account email",
        createAccount: "Impossibile creare l'account email",
        updateAccount: "Impossibile aggiornare l'account email",
        deleteAccount: "Impossibile rimuovere l'account email",
        testConnection: "Impossibile testare la connessione",
        oauthFailed: "Autenticazione OAuth fallita",
        toggleSync: "Impossibile cambiare lo stato della sincronizzazione",
        syncFailed: "Sincronizzazione fallita",
    },
};
